var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-10px"},[_c('video',{staticStyle:{"margin":"auto"},attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.media.path}}),_vm._v(" Sorry, your browser doesn't support embedded videos. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }